import { z } from "zod";
export const tenantPublicLinkStatusSchema = z.enum([
    "pending",
    "active",
    "failed",
    "archived",
]);
export const createTenantPublicLinkSchema = z.object({
    externalId: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .regex(/^[a-zA-Z0-9][a-zA-Z0-9._:-]*$/u),
    destinationUrl: z.url().max(32_000),
    key: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .regex(/^[a-zA-Z0-9_-]+$/u)
        .optional(),
    label: z.string().trim().min(1).max(100).optional(),
});
export const tenantPublicLinkSchema = z.object({
    id: z.string().min(1),
    externalId: z.string().min(1),
    destinationUrl: z.url(),
    dubLinkId: z.string().nullable(),
    domain: z.string().nullable(),
    key: z.string().nullable(),
    shortLink: z.url().nullable(),
    label: z.string().nullable(),
    status: tenantPublicLinkStatusSchema,
    lastError: z.string().nullable(),
    createdAt: z.number().int().nonnegative(),
    updatedAt: z.number().int().nonnegative(),
});
export const tenantPublicLinkResponseSchema = z.object({
    link: tenantPublicLinkSchema,
});
export const listTenantPublicLinksResponseSchema = z.object({
    links: z.array(tenantPublicLinkSchema),
});
